// -----------------------------------------------------------------------------
/**
 * Converts weight value from grams to kilograms if the unit is 'gr'
 * @param value - The weight value
 * @param unit - The unit of the weight (e.g., 'gr', 'kg', 'g')
 * @returns The converted value in kilograms
 */
export const convertWeightToKg = (value: number, unit?: string): number => {
  if (!unit) {
    return value; // Assume kg if no unit specified
  }
  
  const normalizedUnit = unit.toLowerCase();
  
  // Convert grams to kilograms
  if (normalizedUnit === 'gr' || normalizedUnit === 'g') {
    return value / 1000;
  }
  
  // Return as-is for kg, kg/m2, or other units
  return value;
};
